<div
    class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-px-4 tw-py-3 tw-border-t tw-border-gray-200 tw-bg-white tw-gap-4 md:tw-gap-6">
    <!-- Page size selector -->
    <div class="tw-flex tw-items-center tw-space-x-2">
        <span class="tw-text-sm tw-text-gray-700 tw-whitespace-nowrap"
            >{{ 'PAGINATION.ROWS_PER_PAGE' | translate }}:</span
        >
        <mat-form-field
            appearance="outline"
            class="tw-w-20 pagination-form-field">
            <mat-select
                [value]="currentPageSize()"
                (selectionChange)="onPageSizeChange($event.value)"
                class="tw-text-sm">
                @for (size of pageSizeOptions(); track $index) {
                    <mat-option [value]="size">
                        {{ size }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Items info -->
    <div class="tw-flex tw-items-center tw-text-sm tw-text-gray-700">
        {{ getItemsRangeText() }}
    </div>

    <!-- Page navigation -->
    <div class="tw-flex tw-items-center tw-justify-center tw-space-x-2">
        <!-- First page button -->
        <button
            mat-icon-button
            [disabled]="isFirstPage() || loading()"
            (click)="goToFirstPage()"
            matTooltip="{{ 'PAGINATION.FIRST_PAGE' | translate }}">
            <mat-icon fontSet="material-symbols-outlined">first_page</mat-icon>
        </button>

        <!-- Previous page button -->
        <button
            mat-icon-button
            [disabled]="isFirstPage() || loading()"
            (click)="goToPrevPage()"
            matTooltip="{{ 'PAGINATION.PREVIOUS_PAGE' | translate }}">
            <mat-icon fontSet="material-symbols-outlined"
                >chevron_left</mat-icon
            >
        </button>

        <!-- Page input -->
        <div class="tw-flex tw-items-center tw-space-x-2">
            <span class="tw-text-sm tw-text-gray-700">{{
                'PAGINATION.PAGE' | translate
            }}</span>
            <mat-form-field
                appearance="outline"
                class="tw-w-20 pagination-form-field">
                <input
                    matInput
                    [formControl]="pageControl"
                    type="number"
                    [value]="currentPageNumber()"
                    [min]="1"
                    [max]="totalPages()"
                    class="tw-text-sm tw-text-center" />
            </mat-form-field>
            <span class="tw-text-sm tw-text-gray-700"
                >{{ 'PAGINATION.OF' | translate }} {{ totalPages() }}</span
            >
        </div>

        <!-- Next page button -->
        <button
            mat-icon-button
            [disabled]="isLastPage() || loading()"
            (click)="goToNextPageHandler()"
            matTooltip="{{ 'PAGINATION.NEXT_PAGE' | translate }}">
            <mat-icon fontSet="material-symbols-outlined"
                >chevron_right</mat-icon
            >
        </button>

        <!-- Last page button -->
        <button
            mat-icon-button
            [disabled]="isLastPage() || loading()"
            (click)="goToLastPage()"
            matTooltip="{{ 'PAGINATION.LAST_PAGE' | translate }}">
            <mat-icon fontSet="material-symbols-outlined">last_page</mat-icon>
        </button>
    </div>

    <!-- Total count -->
    <div class="tw-flex tw-items-center tw-text-sm tw-text-gray-700">
        {{ 'PAGINATION.TOTAL_ITEMS' | translate }}: {{ totalItems() }}
    </div>
</div>
